export class ProgramDeveloperCIPortfolioSubmissionsNav {
  public static item = {
    title: 'program.tab.ci-portfolios',
    url: 'ci-submissions',
    icon: '<img src="./assets/icons/line-icons/shared/grey/create-portfolio.svg" width="23px" height="23px">',
    testId: 'prog-nav-ci-portfolios',
  };
}
